import styled from "styled-components";

export const ModalWrapper = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 20;
`;

export const OverlayContainer = styled.div`
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0); 
  background-color: rgba(0, 0, 0, 0.4); 
`;

export const ModalContent = styled.div`
  left: 50%;
  top: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  transition: all 500ms ease-in-out;
  border-radius: 10px;
  border: 1px solid #888;
  min-width: 300px;
  height: auto;
  background-color: #fff;
  z-index: 21;
  .close {
    position: absolute;
    top: 10px;
    right: 10px;
  }
`;

export const CloseButton = styled.div`
  width: 25px;
  height: 25px;
  float: right;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
`;